module.exports = __webpack_public_path__ + "static/media/11.1681cdac.jpeg";